import { useEffect } from 'react';

import { useAuth } from '@/services/auth';

const _hsq = (window._hsq = window._hsq || []);

const useHubspot = () => {
    const { isAuthenticated, user } = useAuth();

    useEffect(() => {
        if (isAuthenticated && user && user.email_verified) {
            _hsq.push([
                'identify',
                {
                    email: user.email,
                },
            ]);
            _hsq.push(['trackPageView']);

            window.updateContactInfo?.(user);
        }
    }, [isAuthenticated, user]);
};

export default useHubspot;
